import {
  PaymentSecurityIcon,
  ExchangePolicyIcon,
  FreeShippingIcon,
  BestSupportIcon,
} from "@/components/icons/home-page-icon/service-icon";
import {
  StarFillIcon,
  StarOutlineIcon,
} from "@/components/icons/home-page-icon/popular-of-kalindi";
import {
  StartFillIcon,
  StarUnfillIcon,
} from "@/components/icons/home-page-icon/customer-feedback-icon";

// ------- 1 -> Home Section Data ------- //
export const cetegorycard = [
  {
    bgcolor: "#D2DEE8",
    image: "/assets/images/whatsnew/01.png",
    title: "Cord Set",
    textcolor: "#082640",
    data: [
      {
        name: "Embroidery Saree",
        href: "",
      },
      {
        name: "Patola Saree",
        href: "",
      },
      {
        name: "Pashmina Saree",
        href: "",
      },
      {
        name: "Banarasi Saree",
        href: "",
      },
      {
        name: "Zuri Saree Collection",
        href: "",
      },
      {
        name: "Zeno Saree Collection",
        href: "",
      },
    ],
  },
  {
    bgcolor: "#D2E7E8",
    image: "/assets/images/whatsnew/02.png",
    title: "Tunic",
    textcolor: "#082640",
    data: [
      {
        name: "Embroidery Saree",
        href: "",
      },
      {
        name: "Patola Saree",
        href: "",
      },
      {
        name: "Pashmina Saree",
        href: "",
      },
      {
        name: "Banarasi Saree",
        href: "",
      },
      {
        name: "Zuri Saree Collection",
        href: "",
      },
      {
        name: "Zeno Saree Collection",
        href: "",
      },
    ],
  },
  {
    bgcolor: "#E8D3D2",
    image: "/assets/images/whatsnew/03.png",
    title: "Saree",
    textcolor: "#400808",
    data: [
      {
        name: "Embroidery Saree",
        href: "",
      },
      {
        name: "Patola Saree",
        href: "",
      },
      {
        name: "Pashmina Saree",
        href: "",
      },
      {
        name: "Banarasi Saree",
        href: "",
      },
      {
        name: "Zuri Saree Collection",
        href: "",
      },
      {
        name: "Zeno Saree Collection",
        href: "",
      },
    ],
  },
  {
    bgcolor: "#FFF7E3",
    image: "/assets/images/whatsnew/04.png",
    title: "Dress",
    textcolor: "#403008",
    data: [
      {
        name: "Embroidery Saree",
        href: "",
      },
      {
        name: "Patola Saree",
        href: "",
      },
      {
        name: "Pashmina Saree",
        href: "",
      },
      {
        name: "Banarasi Saree",
        href: "",
      },
      {
        name: "Zuri Saree Collection",
        href: "",
      },
      {
        name: "Zeno Saree Collection",
        href: "",
      },
    ],
  },
  {
    bgcolor: "#E8D2E3",
    image: "/assets/images/whatsnew/05.png",
    title: "Plazo",
    textcolor: "#400833",
    data: [
      {
        name: "Embroidery Saree",
        href: "",
      },
      {
        name: "Patola Saree",
        href: "",
      },
      {
        name: "Pashmina Saree",
        href: "",
      },
      {
        name: "Banarasi Saree",
        href: "",
      },
      {
        name: "Zuri Saree Collection",
        href: "",
      },
      {
        name: "Zeno Saree Collection",
        href: "",
      },
    ],
  },
  {
    bgcolor: "#E0E8D2",
    image: "/assets/images/whatsnew/06.png",
    title: "Kurti",
    textcolor: "#2A4008",
    data: [
      {
        name: "Embroidery Saree",
        href: "",
      },
      {
        name: "Patola Saree",
        href: "",
      },
      {
        name: "Pashmina Saree",
        href: "",
      },
      {
        name: "Banarasi Saree",
        href: "",
      },
      {
        name: "Zuri Saree Collection",
        href: "",
      },
      {
        name: "Zeno Saree Collection",
        href: "",
      },
    ],
  },
];

// ------- 2 -> Service Section Data ------- //
export const servicecard = [
  {
    icon: <PaymentSecurityIcon />,
    title: "Payment Security",
  },
  {
    icon: <ExchangePolicyIcon />,
    title: "Exchange Policy",
  },
  {
    icon: <FreeShippingIcon />,
    title: "Free Shipping",
  },
  {
    icon: <BestSupportIcon />,
    title: "Best Support",
  },
];

// ------- 3 -> Saree Sansnation Section Data ------- //
export const sareecontent = [
  {
    image: "/assets/images/whatsnew/saree/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/saree/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/saree/product/05.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/saree/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/saree/product/05.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
  
  {
    image: "/assets/images/whatsnew/saree/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/saree/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/saree/product/05.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/saree/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/saree/product/05.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/saree/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/saree/product/05.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/saree/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/saree/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/saree/product/05.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
];

// ------- 4 -> Watch And Shop Section Data ------- //
export const whatandshopcontent = [
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_6e5c7fc8-0f70-4c49-aac7-5695861865f7.mp4?v=1700716573",
    viewer: "3.2M",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_5ceb6f2c-1e57-4ee9-b4df-32c9a2186edf.mp4?v=1701237461",
    viewer: "530",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_a08a43a2-0a9e-4d52-a472-be90f441a295.mp4?v=1700716639",
    viewer: "21K",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_6093bffe-a419-41d6-a46f-539e6109e5d0.mp4?v=1701237407",
    viewer: "1.2K",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_034a935a-9d13-4c5b-b4d9-285949ce6961.mp4?v=1698215844",
    viewer: "4.2M",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_6e5c7fc8-0f70-4c49-aac7-5695861865f7.mp4?v=1700716573",
    viewer: "120",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_5ceb6f2c-1e57-4ee9-b4df-32c9a2186edf.mp4?v=1701237461",
    viewer: "3.8M",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_a08a43a2-0a9e-4d52-a472-be90f441a295.mp4?v=1700716639",
    viewer: "9.4K",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_6093bffe-a419-41d6-a46f-539e6109e5d0.mp4?v=1701237407",
    viewer: "16K",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_034a935a-9d13-4c5b-b4d9-285949ce6961.mp4?v=1698215844",
    viewer: "289",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_6e5c7fc8-0f70-4c49-aac7-5695861865f7.mp4?v=1700716573",
    viewer: "100",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_5ceb6f2c-1e57-4ee9-b4df-32c9a2186edf.mp4?v=1701237461",
    viewer: "56.9M",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_a08a43a2-0a9e-4d52-a472-be90f441a295.mp4?v=1700716639",
    viewer: "67.3K",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_6093bffe-a419-41d6-a46f-539e6109e5d0.mp4?v=1701237407",
    viewer: "28.7M",
    href: "",
  },
  {
    video:
      "https://cdn.shopify.com/s/files/1/0026/6544/7536/files/whatmore_tn_034a935a-9d13-4c5b-b4d9-285949ce6961.mp4?v=1698215844",
    viewer: "90.9K",
    href: "",
  },
];

// ------- 5 -> Popular of Kalindi Section Data ------- //
export const popularproduct = [
  {
    image: "/assets/images/whatsnew/popularofkalindi/product/01.svg",
    title: "V-Neck Full-Length Sleeves Top",
    ratting: [
      {
        star: <StarFillIcon />,
      },
      {
        star: <StarFillIcon />,
      },
      {
        star: <StarFillIcon />,
      },
      {
        star: <StarOutlineIcon />,
      },
      {
        star: <StarOutlineIcon />,
      },
    ],
    price: "₹ 2499.00",
  },
  {
    image: "/assets/images/whatsnew/popularofkalindi/product/02.svg",
    title: "Round-Neck Top with Puff Sleeves",
    ratting: [
      {
        star: <StarFillIcon />,
      },
      {
        star: <StarFillIcon />,
      },
      {
        star: <StarFillIcon />,
      },
      {
        star: <StarFillIcon />,
      },
      {
        star: <StarOutlineIcon />,
      },
    ],

    price: "₹ 1522.80",
  },
  {
    image: "/assets/images/whatsnew/popularofkalindi/product/03.svg",
    title: "Graphic Printed Round Neck T-Shirt",
    ratting: [
      {
        star: <StarFillIcon />,
      },
      {
        star: <StarOutlineIcon />,
      },
      {
        star: <StarOutlineIcon />,
      },
      {
        star: <StarOutlineIcon />,
      },
      {
        star: <StarOutlineIcon />,
      },
    ],
    price: "₹ 6895.35",
  },
  {
    image: "/assets/images/whatsnew/popularofkalindi/product/04.svg",
    title: "Printed Top with Flared Sleeves",
    ratting: [
      { star: <StarFillIcon /> },
      { star: <StarFillIcon /> },
      { star: <StarFillIcon /> },
      { star: <StarFillIcon /> },
      { star: <StarFillIcon /> },
    ],

    price: "₹ 1999.00",
  },
  {
    image: "/assets/images/whatsnew/popularofkalindi/product/05.svg",
    title: "Striped V-Neck Top",
    ratting: [
      { star: <StarOutlineIcon /> },
      { star: <StarOutlineIcon /> },
      { star: <StarOutlineIcon /> },
      { star: <StarOutlineIcon /> },
      { star: <StarOutlineIcon /> },
    ],

    price: "₹ 3569.99",
  },
  {
    image: "/assets/images/whatsnew/popularofkalindi/product/06.svg",
    title: "Striped Crew-Neck Top",
    ratting: [
      { star: <StarFillIcon /> },
      { star: <StarFillIcon /> },
      { star: <StarOutlineIcon /> },
      { star: <StarOutlineIcon /> },
      { star: <StarOutlineIcon /> },
    ],

    price: "₹ 8429.87",
  },
];

// ------- 6 -> Casual Wear Section Data ------- //
export const casualwearcontent = [
  {
    image: "/assets/images/whatsnew/casualwear/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/casualwear/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/casualwear/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/casualwear/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/casualwear/product/01.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
  {
    image: "/assets/images/whatsnew/casualwear/product/02.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/casualwear/product/03.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/casualwear/product/04.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/casualwear/product/01.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/casualwear/product/02.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
];

// ------- 7 -> Latest Arrival Section Data ------- //
export const latestarrivalcontent = [
  {
    image: "/assets/images/whatsnew/latestarrival/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/latestarrival/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/latestarrival/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/latestarrival/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/latestarrival/product/05.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
  {
    image: "/assets/images/whatsnew/latestarrival/product/06.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/latestarrival/product/07.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/latestarrival/product/08.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/latestarrival/product/09.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/latestarrival/product/10.png",
    ratting: "4.4",
    href: "",
    title: "Timepiece Haven",
    price: "6874.00",
  },
];

// ------- 7 -> Tunic & Cord Set Section Data ------- //
export const tunicandcordsetcontent = [
  {
    image: "/assets/images/whatsnew/tunicandcirdset/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/tunicandcirdset/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/tunicandcirdset/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/tunicandcirdset/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
  {
    image: "/assets/images/whatsnew/tunicandcirdset/product/01.png",
    ratting: "4.0",
    href: "",
    title: "Timepiece Haven",
    price: "2499.00",
  },
  {
    image: "/assets/images/whatsnew/tunicandcirdset/product/02.png",
    ratting: "3.4",
    href: "",
    title: "Timepiece Haven",
    price: "3699.00",
  },
  {
    image: "/assets/images/whatsnew/tunicandcirdset/product/03.png",
    ratting: "2.1",
    href: "",
    title: "Timepiece Haven",
    price: "5762.28",
  },
  {
    image: "/assets/images/whatsnew/tunicandcirdset/product/04.png",
    ratting: "3.2",
    href: "",
    title: "Timepiece Haven",
    price: "2190.40",
  },
];

// ------- 8 -> Blogs Section Data ------- //
export const blogcontent = [
  {
    image: "/assets/images/whatsnew/blogs/product/01.png",
    title: "My Current Beauty Lineup – All On Sale",
    href: "",
  },
  {
    image: "/assets/images/whatsnew/blogs/product/02.png",
    title: "What to Wear to Every Type Of Fall Wedding",
    href: "",
  },
  {
    image: "/assets/images/whatsnew/blogs/product/03.png",
    title: "My Current Beauty Lineup – All On Sale",
    href: "",
  },
];

// ------- 9 -> Customer Feedback Section Data ------- //
export const customerfeedbackcontent = [
  {
    image: "/assets/images/whatsnew/customerfeedback/clients/04.webp",
    name: "Aditi Sinha",
    location: "Surat, Gujarat",
    ratting: [
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
    ],
    content:
      "A vast range of saree and kurta collection. Very neat embroidery work . The choice of colors and combination is awesome",
  },
  {
    image: "/assets/images/whatsnew/customerfeedback/clients/female.webp",
    name: "Shriya Shah",
    location: "Surat, Gujarat",
    ratting: [
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StarUnfillIcon /> },
    ],
    content:
      "The dresses in your showroom are absolutely stunning! Each piece exudes elegance and style, making it impossible to choose just one favourite.",
  },
  {
    image: "/assets/images/whatsnew/customerfeedback/clients/male.webp",
    name: "Gautam Gangani",
    location: "Surat, Gujarat",
    ratting: [
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StarUnfillIcon /> },
    ],
    content:
      "One Stop solution for an amazing collection of women’s clothing Silk Saree , Embroidered Saree, Retails and Manufacturer. Must visit Once",
  },
  {
    image: "/assets/images/whatsnew/customerfeedback/clients/male.webp",
    name: "Chirag Lathiya",
    location: "Surat, Gujarat",
    ratting: [
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
    ],
    content:
      "Very beautiful collection of Sarees. I purchase from Kalindi for my family and wedding. Beautiful silk sarees. If you looking for wedding sarees collection you must visit Kalindi. Staff was very helpful and great knowledge about fabric.",
  },
  {
    image: "/assets/images/whatsnew/customerfeedback/clients/male.webp",
    name: "Bhargav Patel",
    location: "Surat, Gujarat",
    ratting: [
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
      { rattingstar: <StartFillIcon /> },
    ],
    content: "I think Best Saree and Dress house in surat, because of the cost and quality is excellent. The behave and respond of sellsman is very good, main think is that the quality of Sarees amazing.",
  },
];
